
import layerEvents				from "../utils/layerEvents";
import { 
	Button, 
	Col, 
	Row, 
	Dropdown, 
	Form, 
	Card
}								from "react-bootstrap";
import Select					from "react-select";
import {
	PencilSimple,
	Lightning,
	Windmill,
	BatteryCharging,
	BatteryFull,
	Spiral,
	Ruler,
	Crosshair,
	X,
	Info,
	Eye,
	Trash,
	DotsThreeVertical,
	Wind,
	Calculator,
	Warning,
	CircleNotch,
	Plus,
	Bulldozer,
	ArrowsOutLineVertical,
	ArrowsOutLineHorizontal,
	Bridge,
	UploadSimple,
	Subtract,
	Polygon,
}								from "@phosphor-icons/react";
import DataTable				from 'react-data-table-component';
import atlasApi					from "../utils/atlasapi";
import EditNow					from "../components/EditNow";
import DoNowButton				from "../components/DoNowButton";
import ReactDOM					from "react-dom/client";
import boundaryMode				from "../utils/boundaryMode";
import TurfArea					from '@turf/area';
import TurfBuffer				from '@turf/buffer';
import TurfUnion				from '@turf/union';
import TurfLength				from '@turf/length';
import {
	formatArea,	
	formatDistance, 
	tempId
}								from "../utils/functions";
import MapboxDraw				from "@mapbox/mapbox-gl-draw";
import drawTheme				from "../utils/drawUtilsTheme";
import LayerExclusion			from "../classes/LayerExclusion";
import ExclusionPanel			from "../components/ExclusionPanel";
import ExclusionExtractPanel	from "../components/ExclusionExtractPanel";
import ExclusionUploadPanel		from "../components/ExclusionUploadPanel";
import Tool						from "../classes/Tool";

import circle					from '@turf/circle';

import {
	polygon, 
	point, 
	featureCollection
}								from '@turf/helpers';

const exclusionTypeIcons = {
	polygon : <Polygon size={16} weight="bold" />,
	point : <Crosshair size={16} weight="bold" />,
	terrain : <Subtract size={16} weight="bold" />,
	upload : <UploadSimple size={16} weight="bold" />,
};



class ToolExclusion extends Tool {

	tabIndex			= null;
	highlightedOnList	= [];
	allHidden			= false;
	currentColor		= LayerExclusion.defaultColor;
	currentRadius		= LayerExclusion.defaultRadius;
	
	turbineTypes		= [];
	turbineHeights		= [];
	modified			= false;
	contextMenu			= null;
	lastSelection		= null;
	
	type				= 'exclusion';
	itemsName			= 'exclusion';
	id					= 'exclusion_id';
	infolayerId			= 'exclusions';

	countThisType(type){
		return (this.tc.scenario.exclusion ?? []).filter((e) => e.properties.type === type).length;
	}

	constructor(p, type) {
		super();
		this.parent = p;
		this.draw	= p.draw.draw;
		this.tc		= p;
		this.type	= type;
		
		this.getHiddenItems();
	}

	init(){
		Tool.prototype.init.call(this);
		this.display();
		this.setEventHandlers();
		
		this.stackDrawLayers();
		this.addExclusionLayer();
		
		this.tc.map.getContainer().classList.add("cursor-"+this.type);
		
		if(this.type == 'extract'){	
			this.exit();
			this.tc.handler = new ToolExclusionExtract(this);
			this.tc.handler.init();
		}
		if(this.type == 'upload'){	
			this.exit();
			this.tc.handler = new ToolExclusionUpload(this);
			this.tc.handler.init();
		}
		
	}
	exit(){
		if(this.parent.serviceBar.current)
			this.parent.serviceBar.current.clear(this.tabIndex);
		this.tabIndex = null;
		this.removeEventHandlers();
		
		this.parent.map.getContainer().classList.remove("cursor-polygon");
		this.parent.map.getContainer().classList.remove("cursor-point");
		
		this.unsetStyle();
		this.removeExclusionLayer();
		
		this.closeDrawPanel();
	}
	
	stackDrawLayers = () =>{
		
		drawTheme.forEach((l)=>{
			if(this.tc.map.getLayer(l.id+".cold"))
				this.tc.map.moveLayer(l.id+".cold");
			if(this.tc.map.getLayer(l.id+".hot"))
				this.tc.map.moveLayer(l.id+".hot");
		});
		
	}
	getToolLayer = () => {
		return LayerExclusion;
	}
	setEventHandlers(){
		
		if(!this.parent)
			return;
		Tool.prototype.setEventHandlers.call(this);
		
		this.tc.map.on('click', this.handleClick);
		
		this.tc.map.on('draw.update', this.handleUpdate);
		
		this.tc.map.on('mouseenter', [LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave', [LayerExclusion.layerId], this.handleMouseLeave);
		
		this.tc.map.on('mouseenter', [LayerExclusion.layerId], this.handleCursorChange);
		this.tc.map.on('mouseleave', [LayerExclusion.layerId], this.handleCursorChange);
		
		this.parent.map.on('contextmenu', this.handleRightClick);
	}
	removeEventHandlers(){
		if(!this.parent)
			return;
		Tool.prototype.removeEventHandlers.call(this);
		
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		this.tc.map.off('mouseenter', [LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave', [LayerExclusion.layerId], this.handleMouseLeave);
		
		
		this.tc.map.off('mouseenter', [LayerExclusion.layerId], this.handleCursorChange);
		this.tc.map.off('mouseleave', [LayerExclusion.layerId], this.handleCursorChange);
		
		this.parent.map.off('contextmenu', this.handleRightClick);
	}
	handleClick = (e) => {
		
		if(this.tc.secondaryHandler)
			return;
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerExclusion.layerId]});
		
		if(this.tc.handler.constructor.name == "ToolExclusionPolygon")
			return;
		
		var clickedExclusion	= features && features[0] ? features[0].properties.exclusion_id : false;
		var clickedType			= features && features[0] ? features[0].properties.type : null;

		this.exit();
		
		if(this.tc.handler.constructor.name == "ToolExclusionPoint" && !features.length){
			this.tc.exit();
			this.tc.modeForce('exclude_point_add');
			return;
		}
		if(this.tc.handler.constructor.name == "ToolExclusionExtract" && !features.length){
			this.tc.exit();
			this.tc.modeForce('exclusion_extract');
			return;
		}
		switch(clickedType ?? this.type){
			
			case 'polygon':	
				this.tc.handler = new ToolExclusionPolygon(this, clickedExclusion);
				break;
			case 'upload':	
				this.tc.handler = new ToolExclusionUpload(this, clickedExclusion);
				break;
			case 'terrain':
				this.tc.handler = new ToolExclusionExtract(this, clickedExclusion);
				break;
			case 'point':
				this.tc.handler = new ToolExclusionPoint(this, clickedExclusion);
				break;
		}
		this.tc.handler.init(e);
		
	}

	handleCursorChange = (e)=>{
		this.tc.map.getContainer().classList[e && e.type == 'mouseenter' ? 'add' : 'remove']("cursor-pointer");
		
	}
	handleMouseEnter = (e)=>{
		if(!e.features.length)
			return;
		
		var exclusionId = e.features[0].properties.exclusion_id;
		
		if(exclusionId>-1){
			this.highlightedOnList = [exclusionId];
		}

		
		this.display();
	}
	
	
	handleMouseLeave = (e)=>{
		this.highlightedOnList = [];
		this.display();
	}
	handleRightClick = (e)=>{
		
		e.originalEvent.preventDefault();
		
		var features = this.tc.map.queryRenderedFeatures(e.point, {layers:[LayerExclusion.layerId]});
		
		if(!features.length)
			return;
		
		
		const f = features[0];
		
		var wrp = document.createElement("div");
		wrp.className = "toolContextMenu";
		wrp.style.left = e.point.x+'px';
		wrp.style.top = e.point.y+'px';
		
		this.closeContextMenu();
		
		this.parent.map.getContainer().appendChild(wrp);
		
		this.addMapClickClose();
		ReactDOM.createRoot(wrp).render(this.contextMenuDelete(e, f.properties.exclusion_id, f.geometry.type));
		
	}
	getExclusion = (s, id) => {
		
		if(!s || !id)
			return {};
		
		return s.exclusion.find((e)=>{return e.properties.exclusion_id == id});
	}
	getExclusionFeature = (id) => {
		var data = this.getData();
		
		return data.features.find((e)=>{return e.properties.exclusion_id == id || e.properties.tempid == id});
	}
	getExclusionLabel = (id) => {
		var data = this.getData();
		
		return data.features.find((e)=>{return e.properties.exclusion_id == LayerExclusion.generateLabelId(id) || e.properties.tempid == LayerExclusion.generateLabelId(id)});
	}
	addMapClickClose(){
		
		document.addEventListener("click", this.closeContextMenu);
	}
	highlightOnMap = (row)=>{
		
		const id = row.exclusion_id ?? row?.properties?.tempid;
		
		this.tc.map.setFeatureState({id:id, source:LayerExclusion.sourceId }, {hover:true});
		//for the circles
		this.tc.map.setFeatureState({id:LayerExclusion.generateLabelId(id), source:LayerExclusion.sourceId}, {hover:true});
		
	}
	deHighlightOnMap = (row)=>{
		
		const id = row.exclusion_id ?? row?.properties?.tempid;
		
		this.tc.map.setFeatureState({id:id, source:LayerExclusion.sourceId}, {hover:false});
		
		//for the circles
		this.tc.map.setFeatureState({id:LayerExclusion.generateLabelId(id), source:LayerExclusion.sourceId}, {hover:false});
		
	}
	selectOnMap = ()=>{
		
		const id = this.exclusionId;
		
		this.tc.map.setFeatureState({id:id, source:LayerExclusion.sourceId }, {selected:true});
		//for the circles
		this.tc.map.setFeatureState({id:LayerExclusion.generateLabelId(id), source:LayerExclusion.sourceId}, {selected:true});
		
	}
	deSelectOnMap = ()=>{
		
		const id = this.exclusionId;
		
		this.tc.map.setFeatureState({id:id, source:LayerExclusion.sourceId }, {selected:false});
		//for the circles
		this.tc.map.setFeatureState({id:LayerExclusion.generateLabelId(id), source:LayerExclusion.sourceId}, {selected:false});
		
	}
	
	handleEdit = (row) => {
		
		const exclusionId = row.exclusion_id ?? row?.properties?.tempid;
		
		if(exclusionId === false)
			return;
		

		this.handleSelectionChange();
		
		setTimeout(()=>{
			
			switch(row.type){
				case 'point' : 
					this.tc.handler = new ToolExclusionPoint(this, exclusionId);
					break;
				
				case "polygon" : 
					this.tc.handler = new ToolExclusionPolygon(this, exclusionId);
					break;
					
				case "terrain" : 
					this.tc.handler = new ToolExclusionExtract(this, exclusionId);
					break;
					
				case "upload" : 
					this.tc.handler = new ToolExclusionUpload(this, exclusionId);
					break;
				
			}
			this.tc.handler.init();
			
		}, 50);
		
		
	}
	handleChangeName = (row, index) => {
		document.getElementById('edit-static-exclusion-'+index).dispatchEvent(new MouseEvent("dblclick", {'view': window,'bubbles': true,'cancelable': true}));
	}
	handleCreate = (e) => {
		//it's a new boundary polygon
		if (e.features && e.features[0].id){
			ToolExclusion.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type}
			this.handleUpdate(e, e.features[0].id);
		}
	
		this.exit();
		
		this.exclusionModeForce();
	}
	handleDelete = (e) => {
		if (e.features && e.features[0].id ){
			this.handleUpdate(e, e.features[0].id, true);
			this.exit();
			this.exclusionModeForce();
		}
	}
	handleSelect = (e, row) => {
		const id = "exclusion_id";
		if(!this.selected)
			this.selected = [];
		const idx = this.selected.findIndex((a)=>{return a[id] == row[id]});
		if(idx !== -1){
			this.selected.splice(idx, 1);
		}
		else{
			this.selected.push(row);
		}
		this.display();
	}
	handleSelectAll = () => {
		if (!this.selected) this.selected = [];
		const items = (this.tc.scenario.exclusion ?? []).map(c => ({exclusion_id: c.properties.exclusion_id}));
		const allSelected = items.length > 0 && items.every(d => this.selected.some(s => s.exclusion_id === d.exclusion_id));
		if (allSelected) { this.selected = []; } else { this.selected = items; }
		this.display();
	}
	removeItem = (id) => {
		var s = {...this.tc.scenario};
		const idx = s.exclusion.findIndex(ex => ex.properties.exclusion_id == id);
		if (idx > -1) s.exclusion.splice(idx, 1);
		this.tc.setScenario(s);
		this.deleteFeature("exclusion_id", [id, LayerExclusion.generateLabelId(id)]);
	}

	bulkDeleteApi = (ids) => atlasApi.bulkDeleteExclusions(this.tc.scenario.projectid, this.tc.scenario.scenario_id, ids);

	afterBulkDelete = () => {
		this.exit();
		this.exclusionModeForce();
	}
	handleDeleteFromList(e, exclusionId){
		
		var s = {...this.tc.scenario};
		const idx = s.exclusion.findIndex((ex)=>{return ex.properties.exclusion_id == exclusionId;});
		
		this.deleteExclusion(s.projectid, s.scenario_id, exclusionId);
		this.exit();
		s.exclusion.splice(idx, 1);
		this.tc.setScenario(s);
		//this.tc.record().add(s);
			
		this.exclusionModeForce();
	}
	handleUpdate = (e, pl, del) => {
		
		if(e.action == 'move')
			return;
		//check for boundary update
		var npl = null;
		var self = this;
		const {getters} = this.parent.draw.context;
		
		var nplid = pl ? parseInt(pl.toString().replace(/^\D+/g, '')) : e.features[0].id.toString().replace(/^\D+/g, '');
		
		if(del){
			
			return this.handleDeleteFromList(e, nplid);
		}
		
		if((npl = this.draw.get(pl) ?? e.features[0])){
			
			var s = {...this.tc.scenario};
			const exclusionId = npl.properties.exclusion_id ?? npl.properties.tempid ?? false;
			
			if(exclusionId !== false) {
			

				if(exclusionId>-1){

					const idx = s.exclusion.findIndex((e)=>{return e.properties.exclusion_id == exclusionId;});
					s.exclusion[idx] = npl;

				}
				if(npl.properties.tempid)
					delete npl.id;
			}
			else {
				delete npl.id;
				npl.properties["tempid"] = tempId();
				npl.properties["name"] = "Exclusion zone "+(this.countThisType('polygon')+1);
				npl.properties["type"] = "polygon";
				s.exclusion.push(npl);
				
				
				this.saveExclusion(npl, s.projectid, s.scenario_id);
			}

			//s.modified = 1;
			
			this.tc.setScenario(s);
			//this.tc.record().add(s);
		}
	}
	
	handleSelectionChange = (e) => {	
		//var features = this.map.queryRenderedFeatures(e.point);
		if(!this.parent || !this.parent.scenario || !this.parent.scenario.scenario_id //check if is main scenario
		){
			this.parent.draw.draw.changeMode('simple_select');
		}
		//check if boundary is deselected or a diferent boundary
		
		if (ToolExclusion.lastSelection && (!e.features.length || e.features[0].id != ToolExclusion.lastSelection.id)){
			this.finishLastEdit();
		}
		//check if boundary is selected
		if (e?.features?.length && e.features[0].properties && ['boundary', 'road', 'exclusion'].includes(e.features[0].properties.type) ){
			ToolExclusion.lastSelection = {id: e.features[0].id, type: e.features[0].properties.type};
			return;
		}

	}

	finishLastEdit(e){
		if (ToolExclusion?.lastSelection?.id){
			this.handleUpdate(e, ToolExclusion.lastSelection.id);
			
		}
		ToolExclusion?.currentObj?.exit();
	}
	
	highlightOnList = (id) => {
		this.highlightedOnList.push(parseInt(id));
		
		this.highlightedOnList = [...new Set(this.highlightedOnList)];
		
		this.display();
	}
	deHighlightOnList = (id) => {

		const index = this.highlightedOnList.indexOf(parseInt(id));
		if (index > -1) { 
			this.highlightedOnList.splice(index, 1); 
		}
		this.display();
	}

	pName(row, index){
		return row.name ? row.name : 'Exclusion '+ (index+1);
		
	}
	handleUpdateName = (val, exclusionId) => {
		
		var s = {...this.tc.scenario};
		
			const exclusion = this.getExclusion(s, exclusionId);
			
			var x = null;
			switch(exclusion.properties.type){
				
				case 'point':
					x = new ToolExclusionPoint(this);
					break;
				case 'polygon':
					x = new ToolExclusionPolygon(this);
					break;
				case 'upload':
					x = new ToolExclusionUpload(this);
					break;
				case 'terrain':
					x = new ToolExclusionExtract(this);
					break;
				
			}
			exclusion.properties.name = val;
			
			x.updateExclusion(exclusion, s.projectid, s.scenario_id);
			x.updateMapFeatPop(this.id, exclusionId, {name: val});
			

		this.tc.setScenario(s);
		//this.tc.record().add(s);
	}
	isSelectedOnList = (row)=>{
		return this.highlightedOnList.includes(row.exclusion_id);
	}
	
	contextMenuDelete(map_event, exclusionId){
		return (
			<button className="btn" onClick={(e)=>{this.handleDeleteFromList(map_event, exclusionId); this.closeContextMenu();}}><Trash size={20} /> Remove Exclusion</button>
		);
	}
	closeContextMenu = ()=>{
		
		
		document.removeEventListener("click", this.closeContextMenu);
		
		if(!this.parent)
			return;
		var a = false;
		if(a = this.parent.map.getContainer().querySelector(".toolContextMenu")){
			a.remove();
		}
		
		
	}

	toggleItem(item_id, f, dontRefresh){
		
		const extra = (_item_id, force, hide) => {

			this.tc.map.setFeatureState(
				{
					source: this.getToolLayer().sourceId,
					id: this.getToolLayer().generateLabelId(_item_id)
				},
				{
					invisible:(force != 'undefined' ? force : hide)
				}
			);
			this.tc.map.setFeatureState(
				{
					source: this.getToolLayer().sourceId,
					id: this.getToolLayer().generateCircleId(_item_id)
				},
				{
					invisible:(force != 'undefined' ? force : hide)
				}
			);
		}
		
		super.toggleItem(item_id, f, dontRefresh, extra);
		
	}
	setStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-color', this.currentColor);
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-color', this.currentColor);
	}
	
	unsetStyle(){
		
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.hot', 'circle-color', '#5078FF');
		this.tc.map.setPaintProperty('gl-draw-polygon-and-line-vertex-inactive.cold', 'circle-color', '#5078FF');
	}
	addExclusionLayer(){
		
		this.tc.infoLayers.current.forceVisibility("exclusions", true)
		/*
		this.removeExclusionLayer();
		
		const self = this;
		
		const aux = (new LayerExclusion(this.tc.draw, this.tc.scenario, this.tc)).json();
		
		
		
		this.exclusionLayerPromise = Promise.all(
			aux.images.map(img => new Promise((resolve, reject) => {
				if(this.tc.map.hasImage(img.name)){
					resolve();
					return;
				}
			
				this.tc.map.loadImage(img.src, function (error, res) {
					if(!self.tc.map.hasImage(img.name))
						self.tc.map.addImage(img.name, res);
					resolve();
				})
			}))
		)
		.then(()=>{

			this.tc.map.addSource(LayerExclusion.sourceId, aux.source);

			aux.layer.forEach((l)=>{
				this.tc.map.addLayer(l);
			});
		});
		*/
		
	}
	removeExclusionLayer(){
		this.resetLayer();
		/*
		const b = LayerExclusion.sourceId;
		
		LayerExclusion.layers.forEach((l)=>{
			if(this.tc.map.getLayer(l.id))
				this.tc.map.removeLayer(l.id);
		});
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
						*/
	}


	closeDrawPanel() {
		
		if(!this.tc)
			return;
		var a = false;
		if(a = this.tc.map.getContainer().querySelector(".exclusionModePanel")){
			a.remove();
		}
		
		
	}
	handleUpload(){
		
	}
	openDrawPanel = ()=>{
		
		var wrp = document.createElement("div");
		wrp.className = "exclusionModePanel";
		const {getters} = this.parent.draw.context;
		
		this.closeDrawPanel();
		
		this.tc.map.getContainer().appendChild(wrp);
		
		if(this.type == 'extract'){
			ReactDOM.createRoot(wrp).render(
				<ExclusionExtractPanel 
					setup={{
						open:true, 
						obj: this.getExclusion(this.scenario, this.exclusionId)
					}} 
					handler={this} 
					onChange={this.handleBufferChange} 
					onColorChange={this.handleColorChange} 
					onOpacityChange={this.handleOpacityChange} 
					onSaveClose={this.handleSaveClose} 
					onSaveSettings={this.handleSaveSettings}
					onClose={this.handleOnClose} 
				/>);
		} else if(this.type == 'upload'){
			ReactDOM.createRoot(wrp).render(
				<ExclusionUploadPanel 
					setup={{
						open:true, 
						obj:{
							exclusionId:this.exclusionId, 
							color:this.currentColor
						}
					}} 
					handler={this} 
					onColorChange={this.handleColorChange} 
					onSaveClose={this.handleSaveClose} 
					onUpload={this.handleUpload} 
					user={getters.user} 
					onClose={this.handleOnClose} 
				/>);
			}
		else {
			ReactDOM.createRoot(wrp).render(
				<ExclusionPanel 
					setup={{
						open:true, 
						obj:{
							color:this.currentColor, 
							radius:this.currentRadius
						},
						exclusion: this.getExclusion(this.scenario, this.exclusionId)
					}} 
					handler={this} 
					onDelete={(e)=>{this.handleDeleteFromList(e, this.exclusionId)}} 
					onClose={this.handleOnClose} 
					onColorChange={this.handleColorChange} 
					onSaveClose={this.handleSaveClose} 
					onRadiusChange={this.handleRadiusChange} 
					onRadiusCommit={this.handleRadiusCommit} 
				/>);
		}
	}	
	handleRadiusChange = (radius) => {
		this.currentRadius = radius;
		this.updateDrawing();
	}
	handleRadiusCommit = (radius) => {
		const s = this.tc.scenario;
		const exclusion = this.getExclusion(s, this.exclusionId);
		exclusion.properties.radius = radius;
		this.updateExclusion(exclusion, s.projectid, s.scenario_id);
	}
	
	handleColorChange = (color) => {
		this.currentColor = color;
		this.updateDrawing();
		this.setStyle();
	}
	updateDrawing = () => {
		if(this.currentSelectedDrawing){
			this.draw.setFeatureProperty(this.currentSelectedDrawing, "color", this.currentColor);
			
			const ex = this.getExclusion(this.tc.scenario, this.exclusionId);
			ex.properties.color = this.currentColor;
			
//			const f = this.getExclusionLabel(this.exclusionId);
//			f.properties.color = this.currentColor;
			this.refreshMap();
			//we do this to update the color in real time while the polygon is selected
			this.draw.changeMode(this.draw.getMode(), {featureIds:this.currentSelectedDrawing, featureId:this.currentSelectedDrawing});
			
		}
	}

	exclusionModeForce = () => {
		
		this.tc.handler = new ToolExclusion(this.tc, this.type);
		this.tc.handler.currentColor = this.currentColor ?? LayerExclusion.defaultColor;
		this.tc.handler.currentRadius = this.currentRadius ?? LayerExclusion.defaultRadius;
		this.tc.handler.init();
		
	}
	exclusionModeForce = () => {
		
		this.tc.handler = new ToolExclusion(this.tc, this.type);
		this.tc.handler.currentColor = this.currentColor ?? LayerExclusion.defaultColor;
		this.tc.handler.currentRadius = this.currentRadius ?? LayerExclusion.defaultRadius;
		this.tc.handler.init();
		
	}
	handleOnClose = (e)=>{
		
		
		this.tc.exit();
		
	}
	saveExclusion = (data, pId, sId) => {
		
		const {getters} = this.parent.draw.context;
		
		const payload = {
			coordinates: data.geometry.coordinates[0],
			name:data.properties.name,
			color:data.properties.color,
		}
		
		this.save(atlasApi.createPolyExclusion(payload, pId, sId).then((res)=>{
			this.updateLocalIds(data, res);
		}));
		
	}
	deleteExclusion = (pId, sId, eId) => {
		
		if(!eId)
			return;
		
		this.save(
			atlasApi.updateExclusion(null, pId, sId, eId).then((res)=>{
				if(res.exclusion_id){
					this.deleteFeature("exclusion_id", [res.exclusion_id, LayerExclusion.generateLabelId(res.exclusion_id)]);

				}
			})
		);
		
	}
	updateExclusion = (exclusion, pId, sId) => {
		
		const {getters} = this.parent.draw.context;
		
		const data = {
			name:exclusion.properties.name,
			color:exclusion.properties.color,
		};
		this.save(
			atlasApi.updateExclusion(data, pId, sId, exclusion.properties.exclusion_id).then((res)=>{

			})
		);
	}
	updateLocalIds = (data, res) => {

		this.updateScenarioItemId(this.id,  data.properties.tempid, res.exclusion_id);

		//the main feature
		this.updateMapFeatPop(this.id, data.properties.tempid, {exclusion_id: res.exclusion_id});
		
		//the feature for the label
		this.updateMapFeatPop(this.id, LayerExclusion.generateLabelId(data.properties.tempid), {exclusion_id: LayerExclusion.generateLabelId(res.exclusion_id)});
		
	}
	
	render(){
		const {getters} = this.parent.draw.context;
		

		var lines = (this.tc.scenario.exclusion ?? []).map((c, idx)=>{
			
			return {
				name: c.properties.name ?? 'Exclusion ' + (idx+1),
				number: idx+1,
				exclusion_id: c.properties.exclusion_id,
				type: c.properties.type
			}
		});
		return (
			
			<div className={"project-exclusions "}>
				<div className="title">
					Exclusion zones
					{/*<span onClick={(e)=>{this.parent.exit()}} 	className="btn btn-close alt float-end"><X size={16} /></span>*/}
				</div>
				<div className="scroll">
					<div className="content p-0">

						<DataTable key={123}
							data={lines}
							columns={
								[
									
									{
										name:<Eye onClick={()=>{this.handleHideAllItems()}} className={""+(this.areAllHidden() ? 'opacity-25' : '')} size={16} />,
										id:this.id,
										selector: row => row[this.id],
										format: (row, index) =>	(<Eye onClick={(e)=>{this.handleToggleItem(e, row[this.id], undefined, false)}} id={"bndr_"+row[this.id]} data-id={row[this.id]}  className={""+(this.hiddenItems.includes(row[this.id]) || this.allHidden ? 'opacity-25' : '')} size={16} />),
										maxWidth:"28px !important",
										style: {
											padding: '0',
										}
									},
									{
										name:(
											<Form.Check
												type="checkbox"
												checked={!!(this.tc.scenario.exclusion?.length) && this.tc.scenario.exclusion.every(d => this.selected && this.selected.some(s => s.exclusion_id === d.properties.exclusion_id))}
												ref={el => { if (el) el.indeterminate = !!(this.selected?.length) && this.selected.length < (this.tc.scenario.exclusion?.length ?? 0); }}
												onChange={this.handleSelectAll}
											/>
										),
										selector: row => row.name,
										format: (row,index) => ( <label className="checkbox-pad"><Form.Check type="checkbox" id={"check-"+row.exclusion_id} checked={this.selected && this.selected.some((a)=>a.exclusion_id == row.exclusion_id)} onClick={(e)=>{this.handleSelect(e, row);}} /></label>),
										width:"25px",
										style: { padding: '0px !important'}
									},
									{
										name:'',
										id:'icon',
										selector: (row,index) => {return row.type},
										format: (row) => ( <span className="exclusion-type-icon">{row.type&&exclusionTypeIcons[row.type.toLowerCase()]}</span>),
										width:"24px",
										center: "true",

									},
									{
										name:'Exclusion',
										selector: (row,index) => {return row.name},
										format: (row,index) => (<EditNow id={'exclusion-'+(index)} value={this.pName(row,index)} key={'exclusion-'+(index)} onClick={(e)=>{this.handleEdit(row)}} editable={true} onUpdate={(val)=>{this.handleUpdateName(val, row.exclusion_id)}} />),
										sortable:true,
										width:"100%",
										//maxWidth:"160px !important",
									},

									{
										name:'',
										cell: (row, index) => (
											<div className="context-menu" data-tag="allowRowEvents">
													<Dropdown className="minimal">
														<Dropdown.Toggle className="p-0 px-1" variant="default">
															<DotsThreeVertical size={16} />
														</Dropdown.Toggle>
														<Dropdown.Menu>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleChangeName(row, index);   }}><PencilSimple size={16} /> Change name</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleEdit(row);   }}><PencilSimple size={16} /> Edit exclusion</Dropdown.Item>
															<Dropdown.Item href="#" onClick={(e)=>{ this.handleDeleteFromList(e, (row.exclusion_id ?? row.properties.tempid)); }} className="text-danger" ><Trash size={16} /> Remove exclusion</Dropdown.Item>
														</Dropdown.Menu>
													</Dropdown>
											</div>
										),
										maxWidth:"20px !important"
										//minWidth:"160px !important",
										//maxWidth:"160px !important",
									}
								]
							}
							customStyles={{
								headCells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontWeight:'bold'
									}
								},
								cells:{
									style: {
										padding:'.5rem .3rem',
										minWidth:'0px !important',
										boxSizing:'content-box',
										fontSize: 'var(--bs-body-font-size);',
										color:'var(--bs-body-color)',
										'&:last-child':{paddingRight:'1rem'}
									}
								},
								rows:{
									style: {
										minHeight:"0",
									},
									selectedHighlightStyle:{
										backgroundColor:'red'
									}
								}
							}}
							onRowMouseEnter={this.highlightOnMap}
							onRowMouseLeave={this.deHighlightOnMap}
							onRowClicked={this.handleEdit }
							selectableRowSelected={r=>this.isSelectedOnList(r)}
							highlightOnHover
							selectableRowsHighlight
							pointerOnHover
							sortIcon={<i className="ri-expand-up-down-line" />}
							noDataComponent={

								<Row className="p-0 py-3 m-0">

									<Col xs="1 pe-0">
										<Info className="text-danger" size={15} />
									</Col>
									<Col xs="11 ps-0">
										<b>Please note:</b> There are currently no exclusions in this scenario.
									</Col>



								</Row>
							}
						/>

					{this.selected && !!this.selected.length &&
						<Row className="p-3 batch-action">
							<Col xs="6">
								{this.selected.length} Items selected
							</Col>
							<Col xs="6 text-end">
								<Button variant="primary" onClick={this.handleBulkDelete}>Delete</Button>
							</Col>
						</Row>
					}

					</div>


				</div>

			</div>
			
		);
		
	}
	renderDetail(){
		if(!this.exclusionId)
			return;
		const {getters} = this.tc.draw.context;
		const exclusion = this.getExclusion(this.scenario, this.exclusionId);
		return (
			
			<div className={"project-exclusion"}>
				<div className="title">
					{exclusion.properties.name}
					<span onClick={this.handleOnClose} className="btn btn-close alt float-end"><X size={16} /></span>
				</div>
				<div className="owner-body">

					<div className="road-detail">
					
						<Row className="basic-info mb-2">
							<Col xs="12">
								<Bridge weight="bold" size={16} /> <span>Name: </span>
								{exclusion.properties.name}
							</Col>
						</Row>
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineVertical weight="bold" size={16} /> <span>Type: </span>
								{exclusion.properties.type}
							</Col>
						</Row>
						{exclusion.properties.radius &&
						<Row className="basic-info mb-2">
							<Col xs="12">
								<ArrowsOutLineHorizontal weight="bold" size={16} /> <span>Radius: </span>
								{exclusion.properties.radius} m
							</Col>
						</Row>
						}
					</div>

				</div>

			</div>	
			
		);
		
	}
}


class ToolExclusionPolygon extends ToolExclusion {

	tabIndexPoly = null;
	exclusionId = false;
	
	constructor(p, exclusionId) {
		
		super(p.tc, 'polygon');
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.exclusionId = exclusionId;
		//this.get();
		this.area = 0;
		this.length = 0;
		this.currentColor = p.currentColor;
		
		this.main = p;
		
		return this;
	}
	
	loadExclusion(exclusionId){
		//find clicked boundary 
		if(this.exclusionId === false)
			return;
		
		const exclusion = this.getExclusion(this.scenario, this.exclusionId);
		this.currentColor = exclusion.properties.color;
		
		var plCoords = exclusion.geometry.coordinates;

		const b	= {};
		b.id = 'exclusion_'+this.exclusionId;
		b.type = 'Feature';
		b.properties = {
			type:'polygon', 
			exclusion_id: this.exclusionId,
			color: this.currentColor,
			name: exclusion.properties.name
		};
		b.geometry = {
			type : "Polygon",
			coordinates: plCoords
		}
		this.currentSelectedDrawing = b.id;

		this.draw.add(b);
		
		ToolExclusion.lastSelection = {id: b.id, type: this.type};
		this.draw.changeMode('simple_select', { featureIds: [b.id] });
		
		this.removeFeature(this.exclusionId);
		
		this.stackDrawLayers();
		this.setStyle();
		
		this.display();
	}
	
	init(e){
		Tool.prototype.init.call(this);
		
//		if(this.tc.serviceBar.current)
//			this.tabIndexAdd = this.tc.serviceBar.current.inject(this.render());
//		
		this.addExclusionLayer();
		this.tc.map.getContainer().classList.add("cursor-polygon");
		this.draw.changeMode('simple_select', { featureIds: [] });

		if(this.exclusionId !== false){
			this.loadExclusion();
		}
		else{
			
			this.draw.changeMode('polygon_exclusion_mode', {
				exclusions: this.tc.scenario.exclusion,
				toolExclusion: this,
				startCoordinate: [e.lngLat.lng, e.lngLat.lat]
			});
			this.setStyle();
			this.currentSelectedDrawing = 'added_ex_polygon';
		}
		this.openDrawPanel();
		this.setEventHandlers();
		this.display();
		
	}
	exit(){
		if(this.tc.serviceBar.current && this.tabIndexPoly)
			this.tc.serviceBar.current.clear(this.tabIndexPoly);
		this.tabIndexPoly = null;
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-polygon");
		this.tc.map.getContainer().classList.remove("cursor-pointer");
		this.closeDrawPanel();
		this.removeDrawLayer();
		this.objIdx = null;
		this.currentColor = null;
		this.exclusionId = null;
		ToolExclusion.lastSelection = null;
		this.removeExclusionLayer();
		this.unsetStyle();
		delete this.currentSelectedDrawing;
		
	}
	setEventHandlers(){
		
		Tool.prototype.setEventHandlers.call(this);
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		this.tc.map.on('click',						this.handleClick);
		this.tc.map.on('draw.create',				this.handleCreate);
		this.tc.map.on('draw.delete',				this.handleDelete);
		this.tc.map.on('draw.selectionchange',		this.handleSelectionChange);
		this.tc.map.on('draw.update',				this.handleUpdate);
		
		//this.tc.map.on('mousemove',		this.calculate);

		this.tc.map.on('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		
		Tool.prototype.removeEventHandlers.call(this);
		
		this.removed = 0;
		
		this.tc.map.off('click',			this.handleClick);
		this.tc.map.off('draw.create', this.handleCreate);
		this.tc.map.off('draw.delete',	this.handleDelete);
		this.tc.map.off('draw.selectionchange',	this.handleSelectionChange);
		this.tc.map.off('draw.update', this.handleUpdate);
		
		//this.tc.map.off('mousemove',	this.calculate);
		
		this.tc.map.off('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		
		if(this.main)
			this.main.removeEventHandlers();
		
	}
	
	removeFeature(id){
		
		
		Promise.all([this.exclusionLayerPromise]).then(()=>{

			var data = this.tc.map.getSource(LayerExclusion.sourceId)._options.data;
			//remove the original line
			var idx = data.features.findIndex((p)=>{return p.properties.exclusion_id == id});
			if(idx>-1)
				data.features.splice(idx, 1);

			this.tc.map.getSource(LayerExclusion.sourceId).setData(data);
			
		});
		
	}
	removeDrawLayer(){

		setTimeout(()=>{

			this.draw.deleteAll();
		}, 10);

	}
	handleSelectionChange = (e)=>{
		if(!e?.features?.length){
			//remove all editable drawings and switch to view mode

			this.tc.exit();
			this.tc.modeForce('exclude_polygon_add');
			//this.tc.draw.drawPowerLines(this.scenario, this.tc);
			//issue exit command to refresh viewport (weird bug not deleting the pl linestring
			
		}
	}
	
	handleSaveClose = (e)=>{
		this.updateExclusion(this.getExclusion(this.tc.scenario, this.exclusionId), this.tc.scenario.projectid, this.tc.scenario.scenario_id);
		this.handleOnClose(e);
		
	}
	handleOnClose = (e)=>{
		this.exit();
		this.exclusionModeForce();
	}

	display(){
		if(this.tc.serviceBar.current && this.exclusionId)
			this.tabIndexPoly =	this.tc.serviceBar.current.inject(this.renderDetail(), this.tabIndexPoly);
		else
			super.display();
	}	

}

class ToolExclusionPoint extends ToolExclusion {

	tabIndexPoint = null;
	exclusionId = false;
	
	constructor(p, exclusionId) {
		super(p.tc, 'point');
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.exclusionId = exclusionId;
		//this.get();
		this.area = 0;
		this.length = 0;
		this.currentColor = p.currentColor;
		this.currentRadius = p.currentRadius;
		
		this.main  = p;
		return this;
	}
	
	loadExclusion(){
		//find clicked boundary 
		if(this.exclusionId === false)
			return;
		
		const exclusion = this.getExclusion(this.scenario, this.exclusionId);
		this.currentColor = exclusion.properties.color;
		this.currentRadius = exclusion.properties.radius;
		this.currentCoordinates = exclusion.geometry.coordinates;

		this.selectOnMap();

		this.display();
	}
	
	init(e){
		Tool.prototype.init.call(this);
		
//		if(this.tc.serviceBar.current)
//			this.tabIndexAdd = this.tc.serviceBar.current.inject(this.render());
//		
		this.addExclusionLayer();
		this.tc.map.getContainer().classList.add("cursor-point");

		if(this.exclusionId === false){
			
			this.addPoint(e).then((res)=>{
				
				this.exclusionId = res.properties.exclusion_id;
				this.loadExclusion();
				this.openDrawPanel();
				this.setEventHandlers();
			});
		}
		else {
			this.loadExclusion();
			this.openDrawPanel();
			this.setEventHandlers();
		}
		
		
	}
	addPoint = (e) => {
		
		const p = point([e.lngLat.lng, e.lngLat.lat]);
		p.properties = {
			color:this.currentColor,
			radius: this.currentRadius,
			name: ("Exclusion point " + (this.countThisType('point')+1)),
			type: "point"
		}
		return this.saveExclusion(p, this.tc.scenario.projectid, this.tc.scenario.scenario_id);
		
	}
	
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexAdd);
		this.removeEventHandlers();
		this.deSelectOnMap();
		this.tc.map.getContainer().classList.remove("cursor-point");
		this.tc.map.getContainer().classList['remove']("cursor-pointer");
		this.closeDrawPanel();
		this.tabIndexAdd = null;
		this.objIdx = null;
		this.currentColor = null;
		this.currentRadius = null;
		this.exclusionId = null;
		this.currentCoordinates = null;
		ToolExclusion.lastSelection = null;
		this.removeExclusionLayer();
		this.closeDrawPanel();
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		
		Tool.prototype.setEventHandlers.call(this);
		
		this.tc.map.on('click',			this.handleClick);
		this.tc.map.on('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		Tool.prototype.removeEventHandlers.call(this);
		this.tc.map.off('click',			this.handleClick);
		this.tc.map.off('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		if(this.main)
			this.main.removeEventHandlers();
		
	}
	saveExclusion = (data, pId, sId) => {
		
		
		return this.save(
			atlasApi.createPointExclusion(this.convertData(data), pId, sId).then((res)=>{
				if(res.exclusion_id){
					var res = this.convertDataIn(res);
					var s = {...this.tc.scenario};
					var d = this.getData();



					const point = s.exclusion.find((p)=>{ return p.properties.exclusion_id == res.properties.exclusion_id})
					if(point){
						point = {
							...point,
							...res
						};
					}
					else {
						s.exclusion.push(res);
					}


					this.tc.setScenario(s);
					this.resetLayer();

					return res;
				}
				return false;
			})
		);
		
	}
	
	convertData(point){
		
		return {
			"lat": point.geometry.coordinates[1],
			"lon": point.geometry.coordinates[0],
			"name": point.properties.name,
			"radius": point.properties.radius,
			"color": point.properties.color,
		}
		
	}
	convertDataIn(point){
		
		if(!point.exclusion_id)
			return {};
		
		return {
			geometry: point.geom,
			properties : {
				color: point.color,
				radius: point.radius,
				type: point.type,
				exclusion_id: point.exclusion_id,
				name: point.name,
			}
		}
		
	}
	
	
	updateDrawing = () => {
		if(this.exclusionId !== false){
			
			
			const newfeature = circle(this.currentCoordinates, this.currentRadius, { steps: 40, units: "meters", properties: { exclusion_id: this.exclusionId } });
			
			this.updateMapFeatCoordinates(this.exclusionId, newfeature.geometry.coordinates, (f)=>{return f.geometry.type == 'Polygon'})
			
			this.updateMapFeatPop("exclusion_id",this.exclusionId, {color: this.currentColor, radius: this.currentRadius},  (f)=>{return f.geometry.type == 'Polygon'} );
				
			this.updateMapFeatPop("exclusion_id",this.exclusionId, {color: this.currentColor},  (f)=>{return f.geometry.type == 'Point'} );
			

		}
	}
	updateExclusion = (exclusion, pId, sId) => {
		
		const {getters} = this.parent.draw.context;
		
		const data = {
			...this.convertData(exclusion)
		};
		this.save(
			atlasApi.updateExclusion(data, pId, sId, exclusion.properties.exclusion_id).then((res)=>{

			})
		);
	}
	
	
	handleSaveClose = (e)=>{
		this.updateExclusion(this.getExclusion(this.tc.scenario, this.exclusionId), this.tc.scenario.projectid, this.tc.scenario.scenario_id);
		this.handleOnClose(e);
		
	}
	handleOnClose = (e)=>{
		this.exit();
		this.exclusionModeForce();
	}


	display(){
		if(this.tc.serviceBar.current)
			this.tabIndexPoint =	this.tc.serviceBar.current.inject(this.renderDetail(), this.tabIndexPoint);
	}	

}

class ToolExclusionExtract extends ToolExclusion {

	tabIndexExt = null;
	exclusionId = false;
	
	constructor(p, exclusionId) {
		super(p.tc, 'extract');
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.exclusionId = exclusionId;
		//this.get();
		this.area = 0;
		this.currentType = 0;
		this.currentColor = p.currentColor;
		this.currentRadius = p.currentRadius;
		
		this.main  = p;
		return this;
	}
	

	
	init(e){
		Tool.prototype.init.call(this);
		this.tc.map.getContainer().classList.add("cursor-polygon");

		this.openDrawPanel();
		this.addBufferLayer();
		this.setEventHandlers();

		if(this.exclusionId){
			this.loadExclusion();
		}
		this.display();

	}
	loadExclusion(){
		if(this.exclusionId === false)
			return;

		const exclusion = this.getExclusion(this.scenario, this.exclusionId);
		this.currentColor = exclusion.properties.color;
		this.currentOpacity = exclusion.properties.opacity;
		this.currentType = exclusion.properties.extractType ?? 0;
		this.currentBuffer = exclusion.properties.buffer ?? 0;
		this.currentSlope = exclusion.properties.slope ?? 0;

		this.selectOnMap();
		this.display();
		this.openDrawPanel();
	}

	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexExt);
		this.removeEventHandlers();
		this.removeBufferLayer();
		this.tc.map.getContainer().classList.remove("cursor-polygon");
		this.tabIndexExt = null;
		this.objIdx = null;
		ToolExclusion.lastSelection = null;
		this.removeExclusionLayer();
		this.closeDrawPanel();
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		Tool.prototype.setEventHandlers.call(this);
		
		//this.tc.map.on('mousemove',		this.calculate);
		this.tc.map.on('click',			this.handleClick);
		this.tc.map.on('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		Tool.prototype.removeEventHandlers.call(this);
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		if(this.main)
			this.main.removeEventHandlers();
		
	}
	handleSaveClose = ()=>{
		
		
		if(this.currentType && this.currentBuffer){
			this.save(
				atlasApi.extractExclusion(this.tc.scenario.projectid, this.tc.scenario.scenario_id, this.currentType, this.currentSlope ?? 0, this.currentBuffer).then((res)=>{

					if(res.exclusion_id){
						const poly = {
							geometry: res.geom,
							properties:{
								color:res.color,
								type: res.type,
								exclusion_id: res.exclusion_id,
								name: res.name
							},
							type:'Feature'
						}
						this.addNewExclusion(poly);
						this.handleOnClose();
					}	
				})
			);
		}
		else {
			this.handleOnClose();
		}
	}
	handleBufferChange = ({type, slope, buffer}) => {
		
		this.currentType = type;
		this.currentBuffer = buffer;
		this.currentSlope = slope;
		
		const bound = polygon(this.tc.scenario.boundary.geometry.coordinates[0]);
		const bufferPolygon = TurfBuffer(bound, buffer, { units: 'kilometers' });
		
		//const coll = featureCollection([bufferPolygon, bound]); 
		const outside = TurfUnion(bufferPolygon, bound);

		this.tc.map.getSource(this.type+'_buffer').setData({
			type: 'FeatureCollection',
			features: [outside]
		});
	}
	handleSaveSettings = () => {
		
		const data ={
			opacity: this.currentOpacity,
			color:this.currentColor
		}
		
		this.saveExclusion(data, this.tc.scenario.projectid, this.tc.scenario.scenario_id);
	}
	saveExclusion = (data, pId, sId) => {
		
		const {getters} = this.parent.draw.context;
		
		const payload = {
			...{data}
		}
		this.save(
			atlasApi.updateExclusion(payload, pId, sId, this.exclusionId).then((res)=>{

			})
		);
		
	}
	handleColorChange = (color) => {
		
		this.currentColor = color;
		this.updateDrawing();
	}
	handleOpacityChange = (opacity) => {
		
		this.currentOpacity = opacity;
		this.updateDrawing();
	}
	updateDrawing = () => {
		
		
		this.updateMapFeatPop("exclusion_id", this.exclusionId, {color:this.currentColor, opacity:this.currentOpacity});
		this.updateScenarioFeatPop("exclusion_id", this.exclusionId, {color:this.currentColor, opacity:this.currentOpacity});
		
	}
	addNewExclusion(poly){
		
		var s = {...this.tc.scenario};
		var data = this.getData();
		
		s.exclusion.push(poly);
		data.features.push(poly);
		
		this.tc.setScenario(s);
		this.setData(data);
		
	}
	addBufferLayer(){
		this.removeBufferLayer();
		this.tc.map.addSource(this.type+'_buffer', {
			type: 'geojson',
			data: {
				type: 'FeatureCollection',
				features: []
			}
		});

		this.tc.map.addLayer({
			id: this.type+'_buffer-fill',
			type: 'fill',
			source: this.type+'_buffer',
			paint: {
				'fill-color': LayerExclusion.defaultColor,
				'fill-opacity': 0.3,
			}
		});
		this.tc.map.addLayer({
			id: this.type+'_buffer-line',
			type: 'line',
			source: this.type+'_buffer',
			paint: {
				'line-color': LayerExclusion.defaultColor,
				'line-width': 2,
				'line-dasharray': [2,2]
			}
		});
	}
	removeBufferLayer(){
		const l = this.type+'_buffer-fill';
		const ll = this.type+'_buffer-line';
		const b = this.type+'_buffer';
		if(this.tc.map.getLayer(l)){
			this.tc.map.removeLayer(l);
		}
		if(this.tc.map.getLayer(ll)){
			this.tc.map.removeLayer(ll);
		}
		if(this.tc.map.getSource(b)){
			this.tc.map.removeSource(b);
		}
	}

	display(){
		if(this.exclusionId && this.tc.serviceBar.current)
			this.tabIndexExt =	this.tc.serviceBar.current.inject(this.renderDetail(), this.tabIndexExt);
		else
			super.display();
	}	

}
class ToolExclusionUpload extends ToolExclusion {

	tabIndexAdd = null;
	exclusionId = false;
	
	constructor(p, exclusionId) {
		super(p.tc, 'upload');
		//this.tc = this.parent.parent;
		this.scenario = this.tc.scenario;
		this.draw = this.tc.draw.draw;
		this.exclusionId = exclusionId ?? false;
		
		this.main  = p;
		return this;
	}

	loadExclusion(){
		//find clicked boundary 
		if(this.exclusionId === false)
			return;
		
		const exclusion = this.getExclusion(this.scenario, this.exclusionId);
		this.currentColor = exclusion.properties.color;
		
	}

	
	init(e){
		Tool.prototype.init.call(this);
		this.tc.map.getContainer().classList.add("cursor-polygon");

		if(this.exclusionId !== false){
			this.loadExclusion();
		}
		this.openDrawPanel();
		this.setEventHandlers();
		this.display();
		
	}

	
	exit(){
		if(this.tc.serviceBar.current)
			this.tc.serviceBar.current.clear(this.tabIndexAdd);
		this.removeEventHandlers();
		this.tc.map.getContainer().classList.remove("cursor-polygon");
		this.tabIndexAdd = null;
		this.objIdx = null;
		ToolExclusion.lastSelection = null;
		this.removeExclusionLayer();
		this.closeDrawPanel();
	}
	setEventHandlers(){
		
		if(!this.tc)
			return;
		
		this.removed = 1;
		
		Tool.prototype.setEventHandlers.call(this);
		//this.tc.map.on('mousemove',		this.calculate);
		this.tc.map.on('click',			this.handleClick);
		this.tc.map.on('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.on('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		
		
	}
	removeEventHandlers(){
		if(!this.parent || !this.removed)
			return;
		this.removed = 0;
		Tool.prototype.removeEventHandlers.call(this);
		this.tc.map.off('click', this.handleClick);
		this.tc.map.off('mouseenter',	[LayerExclusion.layerId], this.handleMouseEnter);
		this.tc.map.off('mouseleave',	[LayerExclusion.layerId], this.handleMouseLeave);
		if(this.main)
			this.main.removeEventHandlers();
		
	}
	handleUpload = (res) => {
		if(res.exclusion_id){
			const poly = {
				geometry: res.geom,
				properties:{
					color:res.color,
					type: res.type,
					exclusion_id: res.exclusion_id,
					name: res.name
				},
				type:'Feature'
			}
			this.addNewExclusion(poly);
			this.handleOnClose();
		}	
	}
	handleColorChange = (color) => {
		
		this.currentColor = color;
		this.updateDrawing();
	}
	updateDrawing = () => {
		
		
		this.updateMapFeatPop("exclusion_id", this.exclusionId, {color:this.currentColor});
		this.updateScenarioFeatPop("exclusion_id", this.exclusionId, {color:this.currentColor});
		
	}

	handleSaveClose = ()=>{
		
		
		if(this.currentColor && this.exclusionId){
			
			const payload = this.getExclusion(this.tc.scenario, this.exclusionId);
			
			this.saveExclusion(payload);
		}
		else {
			this.handleOnClose();
		}
	}

	saveExclusion = (data) => {
		
		const {getters} = this.parent.draw.context;
		
		
		this.updateExclusion(data, this.tc.scenario.projectid, this.tc.scenario.scenario_id);
	}
	addNewExclusion(poly){
		
		var s = {...this.tc.scenario};
		var data = this.getData();
		
		s.exclusion.push(poly);
		data.features.push(poly);
		
		this.tc.setScenario(s);
		this.setData(data);
		
	}
}

export { ToolExclusion, ToolExclusionPolygon, ToolExclusionUpload};